import type { TourDefinition } from './tourTypes';

export const ADD_COURSE_TOUR_ID = 'add-course-onboarding';
export const ADD_COURSE_TARGET_ID = 'add-course-button';

export const COURSE_AI_SETTINGS_TOUR_ID = 'course-ai-settings';
export const COURSE_AI_SETTINGS_TARGET_ID = 'course-ai-settings-button';

export const CHAPTER_AI_SETTINGS_TOUR_ID = 'chapter-ai-settings';
export const CHAPTER_AI_SETTINGS_TARGET_ID = 'chapter-ai-settings-button';

// Tour ids are persisted in User.dismissed_tours forever, so they must stay
// stable once shipped — renaming one re-shows the tour to everyone who already
// dismissed it.
//
// The two AI settings tours are deliberately separate: they teach the two halves
// of the same rule from opposite sides (the course sets the default, a chapter
// overrides it), they live on different pages, and an instructor who has learned
// one has not necessarily met the other. Separate ids also mean dismissing one
// never silences the other.
//
// Order matters — the provider starts the FIRST eligible tour. Course-level comes
// first so that, in the unlikely event both targets are mounted at once, the
// default is explained before the override.
export const productTours: TourDefinition[] = [
  {
    audience: 'student',
    id: ADD_COURSE_TOUR_ID,
    steps: [
      {
        body: 'Select Add Course, then enter the course ID from your instructor.',
        placement: 'bottom',
        targetId: ADD_COURSE_TARGET_ID,
        title: 'Sign up for a course',
      },
    ],
  },
  {
    audience: 'instructor',
    id: COURSE_AI_SETTINGS_TOUR_ID,
    steps: [
      {
        body: 'Set AI hints, practice problems, and the Kai assistant for every chapter in this course. A chapter can override any of them.',
        placement: 'bottom',
        targetId: COURSE_AI_SETTINGS_TARGET_ID,
        title: 'Course AI defaults',
      },
    ],
  },
  {
    audience: 'instructor',
    id: CHAPTER_AI_SETTINGS_TOUR_ID,
    steps: [
      {
        body: 'Adjust AI hints, practice problems, and the Kai assistant for this chapter. Anything you set here overrides the course default.',
        placement: 'bottom',
        targetId: CHAPTER_AI_SETTINGS_TARGET_ID,
        title: 'AI settings for this chapter',
      },
    ],
  },
];
